import "./Section.scss";

const Section = (props) => {
  return <section className="Section">{props.children}</section>;
};

export default Section;
